export default __webpack_public_path__ + "static/media/drop.eb322d36.png";